import { r as registerInstance, h } from './index-5faac9d7.js';
import { d as debounce_1 } from './debounce-e0de1804.js';
import { a8 as DEBOUNCED_HANDLER_DELAY } from './currency-49e0d692.js';
import { P as PRODUCTS_PLACEHOLDER } from './label-placeholders-68407765.js';
import { t as tryParse } from './index-39f51a91.js';
import { i as isMobile } from './utils-6c8f178b.js';
import './_nodeUtil-549406aa.js';
import './_commonjsHelpers-7db8bc26.js';
import './toNumber-d92ee08f.js';
import './isSymbol-8fefec05.js';
import './analytics-b3108572.js';
import './lodash-7f024380.js';
import './_Stack-cf94d4e7.js';

const ICONS = {
  89000: 'media',
  88941: 'weather_snow',
  88986: 'it_screen',
  88948: 'electricity_socket_shouco',
  88957: 'segment_datacentre',
  88953: 'it_server',
  88961: 'burglar_alarm',
  89208: 'user_oem',
  88968: 'electrical_plug3',
  88972: 'battery2_charging',
};

const allProductsCss = ".all-products{background-color:#f7f7f7}@media screen and (max-width: 979px){.all-products{display:flex;flex-direction:column-reverse}}.all-products__main-content{position:relative}@media screen and (min-width: 980px){.all-products__main-content{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:center;padding-bottom:30px}.all-products__main-content--menu-opened::after{content:\"\";position:absolute;left:0;right:0;top:58px;bottom:0;background:#666666;opacity:0.7;z-index:1}}@media screen and (max-width: 979px){.all-products__header{margin:0;color:#333333;text-align:center;padding:24px 0 16px;font-size:24px;line-height:36px;font-weight:700;width:100%}}@media screen and (min-width: 980px){.all-products__header{display:none}}@media screen and (min-width: 980px){.all-products__section{display:flex;flex-wrap:wrap;width:1200px;max-width:1200px;padding:0;box-sizing:border-box}.all-products__section *,.all-products__section *::before,.all-products__section *::after{box-sizing:inherit}}.all-products__section--inactive{display:none}.all-products__section-title-wrapper{display:none}@media screen and (min-width: 980px){.all-products__section-title-wrapper{display:flex;flex-basis:100%;height:52px}}.all-products__section-title{display:inline-flex;align-items:center;padding:0 10px;font-size:22px;line-height:30px;font-weight:700;color:#333333;text-decoration:none}.all-products__section-title-icon{position:relative;top:2px}:host(:not([dir=\"rtl\"])) .all-products__section-title-icon{left:8px}:host([dir=\"rtl\"]) .all-products__section-title-icon{right:8px;transform:scaleX(-1)}@media screen and (min-width: 980px){.all-products__top-categories{display:block;width:100%}}.all-products__menu-category{display:none}@media screen and (min-width: 980px){.all-products__menu-category{position:relative;display:block;width:25%;padding:6px 10px 0}}@media screen and (min-width: 980px){.all-products__top-runners{display:flex;flex-flow:wrap;align-content:flex-start;width:75%}}";

const AllProductsAPC = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.resizeWindow = () => {
      this.isMobile = isMobile();
    };
    this.debouncedHandleResize = debounce_1(this.resizeWindow, DEBOUNCED_HANDLER_DELAY);
    this.handleBusinessLineDidClick = ({ detail, }) => {
      if (detail === null || detail === void 0 ? void 0 : detail.url) {
        window.open(detail.url, '_self');
      }
    };
    this.categories = undefined;
    this.toprunners = undefined;
    this.appProductsLabel = undefined;
    this.breadCrumbsAllProductsLabel = undefined;
    this.viewOnLabel = undefined;
    this._categories = undefined;
    this._toprunners = undefined;
    this._appProductsLabel = undefined;
    this._breadCrumbsAllProductsLabel = undefined;
    this._viewOnLabel = undefined;
    this.isPBS = false;
    this.isMobile = isMobile();
  }
  componentWillLoad() {
    var _a, _b, _c, _d, _e;
    this.categories = (_a = tryParse(this._categories)) !== null && _a !== void 0 ? _a : this.categories;
    this.toprunners = (_b = tryParse(this._toprunners)) !== null && _b !== void 0 ? _b : this.toprunners;
    this.appProductsLabel = (_c = tryParse(this._appProductsLabel)) !== null && _c !== void 0 ? _c : this.appProductsLabel;
    this.breadCrumbsAllProductsLabel = (_d = tryParse(this._breadCrumbsAllProductsLabel)) !== null && _d !== void 0 ? _d : this.breadCrumbsAllProductsLabel;
    this.viewOnLabel = (_e = tryParse(this._viewOnLabel)) !== null && _e !== void 0 ? _e : this.viewOnLabel;
  }
  connectedCallback() {
    window.addEventListener('resize', this.debouncedHandleResize);
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.debouncedHandleResize);
  }
  render() {
    return (h("div", { class: "all-products" }, h("pes-business-lines-view", { linesList: this.categories, isMobile: this.isMobile, iconNameMap: ICONS, onBusinessLineDidClick: this.handleBusinessLineDidClick, isPBS: this.isPBS }), h("main", { class: "all-products__main-content" }, h("h1", { class: "all-products__header" }, this.breadCrumbsAllProductsLabel), h("section", { class: "all-products__section" }, h("pes-top-categories", { class: "all-products__top-categories", list: this.toprunners, viewOnLabel: this.viewOnLabel, cardCountLabel: this.appProductsLabel, cardCountPlaceholder: PRODUCTS_PLACEHOLDER, isMobile: this.isMobile })))));
  }
};
AllProductsAPC.style = allProductsCss;

export { AllProductsAPC as pes_all_products_apc };
